export const personalInfo = {
	name: "Altin Selimi",
	title: "Senior Frontend Engineer",
	phone: "+31 6 38232705",
	web: "altinselimi.com",
	email: "selimialtin[at]gmail.com",
	location: "Amsterdam, Netherlands",
};

export const experiences = [
	{
		companyName: "Grasp",
		companyUrl: "https://getgrasp.com",
		role: "Senior Frontend Engineer",
		year: "2020 (Ongoing)",
		location: "Amsterdam",
		companyDescription:
			"Grasp makes communication between companies and customers simpler, faster and a lot more fun. Easily collaborate, automate conversations, and answer questions before they're even asked.",
		achievements: [
			{
				title: "Grasp Inbox (Vue 3)",
				description:
					"Developed the new Grasp Inbox using modern frontend technologies like Vue 3, and storybook for component integration.",
			},
			{
				title: "App support (AngularJS, Vue 2)",
				description:
					"Implementations and maintenance in existing applications.",
			},
			{
				title: "Modern component libraries (Vue, Storybook)",
				description:
					"Created components library specific to the needs of the company.",
			},
			{
				title: "Deep analysis and feedback on all things Frontend",
				description:
					"Analysis on the performance of applications, including FCP & FMP.",
			},
		],
	},
	{
		companyName: "Mapme",
		companyUrl: "https://mapme.com",
		role: "Frontend Engineer",
		year: "2020",
		location: "Prishtina",
		companyDescription:
			"Mapme is used to create interactive maps across all industries: non-profits, cities, real estate, construction, retail, and travel, just to name a few.",
		achievements: [
			{
				title: "App support (Vue, Angular)",
				description:
					"Feature implementations and maintenance on existing projects.",
			},
			{
				title: "Concepts and implementations on UI/UX",
				description:
					"Making sure basic UI rules are followed, and also ideating and implementing some features like the draggable card which turned out to be a great success",
			},
		],
	},
	{
		companyName: "Wise (now SolidFi)",
		companyUrl: "https://solidfi.com",
		role: "Frontend Engineer - Team Lead",
		year: "2019",
		location: "Prishtina / San Francisco",
		companyDescription:
			"Wise is a fin-tech startup targeting small/mid business companies. In their basic package, they offer 2% APY interest and instant payments, state-of-the-art onboarding on the web and mobile applications.",
		achievements: [
			{
				title: "Client Application (Vue, AWS)",
				description:
					"Onboarding app and Dashboard app creation and maintenance.",
			},
			{
				title: "Mentoring",
				description:
					"Mentored and lead a team of 3 on web app implementations.",
			},
			{
				title: "Wise Library",
				description:
					"Created and helped maintain the frontend library which was to be used in all of our web applications.",
			},
		],
	},
	{
		role: "Frontend/Mobile Developer",
		companyUrl: "https://azavista.com",
		year: "2018 - 2019",
		companyName: "Azavista",
		location: "Prishtina / Amsterdam",
		companyDescription:
			"Azavista helps corporate events and conference professionals to streamline event planning and improve the event experience.",
		achievements: [
			{
				title: "Client Application (Ionic, Angular)",
				description:
					"Implemented and launched the client application which had some real engineering done to account for offline scenarios. That's because in highly crowded events, it was rather usual for connectivity to go down. So we had to implement queuing which would still allow organizers to go on without depending on it.",
			},
		],
	},
	{
		role: "Frontend Developer",
		companyUrl: "https://casetab.io",
		year: "2017 - 2018",
		companyName: "CaseTab",
		location: "Prishtina / New York",
		companyDescription:
			"CaseTab is a case management system and a client communications tool that helps organizations quickly build forms, reports, and visualizations that just work on mobile.",
		achievements: [
			{
				title: "Client Application (VueJS)",
				description:
					"Redesigned and implemented CaseTab client application.",
			},
			{
				title: "Internal Applications (VueJS)",
				description:
					"Implemented and migrated various server-implementation frontends to VueJS.",
			},
		],
	},
	{
		role: "Frontend Developer",
		companyUrl: "https://hotelkeyapp.com",
		companyName: "HotelKey",
		year: "2016 - 2018",
		location: "Prishtina / Dallas",
		companyDescription:
			"HotelKey is a cloud-based Property Management System designed for hospitality Industry. They provide software solutions that are efficient, reliable, and easy to use.",
		achievements: [
			{
				title: "Internal Application (Angular 1)",
				description:
					"Helped implementation of the back-office main application HKAdmin.",
			},
			{
				title: "Client Application (Angular 2)",
				description:
					"Designed and implemented BI as a sub-application.",
			},
			{
				title: "Internal Application (VueJS)",
				description:
					"Implement web templates generator, named HKWebsite.",
			},
			{
				title: "Client Application (VueJS)",
				description:
					"Implemented the booking module. Mentored and helped implementation of HKCallCenter",
			},
		],
	},
];

export const frontendSkills = [
	"VueJS",
	"React",
	"Angular",
	"Svelte",
	"Vite",
	"Webpack",
	"ParcelJS",
	"TypeScript",
];

export const backendSkills = ["NodeJS", "Basic SQL (Using ORM libraries)"];

export const mobileSkills = ["React Native", "Ionic", "Quasar", "NativeScript"];

export const funProjects = [
	{
		name: "🗓️ Kalendar",
		description: `This is a Calendar library which is pretty much an implementation similar to what Google offers, but oriented to developer needs rather than client needs. \n\nIt has dragging (to create events) capabilities and also utilizes Web Workers to achieve blazing fast speeds when navigating between weeks.`,
		url: "https://github.com/altinselimi/kalendar",
	},
	{
		name: "🦉 Monimo",
		description: `This application was made by anime fans, for anime fans, around the idea that having a great user experience, is as important as having basic features. \n\nBut we don't lack on features either. We've got: Autoplay, Next Episode, and Resume playing!`,
		url: "https://github.com/altinselimi/monimo",
	},
];
